<template>
  <v-div border-inverted-bottom-thick mt-3 pb-3>
    <h2 v-if="showLabel" class="v-div mb-2 ml-2 font-weight-bold font-smaller">
      Keywords
    </h2>
    <v-div font-smaller>
      <KeywordTag
        v-for="(keyword, index) in article.keywords"
        :key="index"
        :keyword="keyword"
      />
    </v-div>
  </v-div>
</template>

<script>
import KeywordTag from "~/components/articles/components/KeywordTag.vue";

export default {
  name: "KeywordTags",
  components: { KeywordTag },
  props: {
    article: { type: Object, required: true },
    showLabel: { type: Boolean, default: true },
  },
};
</script>
